import type { WorkspaceAuditAction } from './types'

// Explicitly request the admin-facing events, including for “All actions”.
// Filtering at the API keeps hidden categories out of paginated results.
export const visibleAuditActions: WorkspaceAuditAction[] = [
  'CONVERTED_TO_INVOICE_PAYMENT',
  'CANCEL_LICENSE',
  'CREATE_PERMISSION_GROUP',
  'CREATE_PERMISSION_GROUP_RELATION',
  'ADD_MEMBER_PERMISSION_GROUP',
  'UPDATE_PERMISSION_GROUP',
  'DELETE_PERMISSION_GROUP',
  'REMOVE_MEMBER_PERMISSION_GROUP',
  'REMOVE_PERMISSION_GROUP_RELATION',
  'INSTALL_INTEGRATION',
  'UNINSTALL_INTEGRATION',
  'CREATE_MEMBERSHIP',
  'UPDATE_MEMBERSHIP',
  'DELETE_MEMBERSHIP',
  'ACCEPT_MEMBERSHIP_INVITE',
  'DISABLE_MEMBERSHIP',
  'RESTORE_MEMBERSHIP',
  'SSO_MEMBERSHIP_PROVISIONED',
  'DOWNGRADED_SSO_MEMBERSHIP_PROVISIONED',
  // Unknown events remain visible, but are not offered in the action filter.
  'UNKNOWN',
  'CHANGED_PLAN',
  'CREATE_PREVIEW',
  'UPDATE_PREVIEW',
  'ADD_PREVIEW_PASSWORD',
  'REMOVE_PREVIEW_PASSWORD',
  'REFRESH_PREVIEW',
  'DELETE_PREVIEW',
  // Public profile events are temporarily hidden. Uncomment to restore them.
  // 'CHANGE_WORKSPACE_PROFILE_ENABLED',
  // 'CHANGE_WORKSPACE_PROFILE_IS_OFFICIAL',
  // 'CHANGE_WORKSPACE_PROFILE_SHORT_URL',
  // 'CHANGE_WORKSPACE_PROFILE_VISIBILITY',
  'ARCHIVE_PROJECT',
  'UNARCHIVE_PROJECT',
  'CHANGE_ACCOUNT_LINKING',
  'CHANGE_SCIM_AUTO_LINK',
  'CHANGE_SECURITY_EMAIL',
  'CONFIGURE_ENCRYPTION_KEYS',
  'RESET_SCIM_TOKEN',
  'SET_SCIM_ENABLED',
  'SET_SSO_CONFIG',
  'SET_SSO_ELIGIBILITY',
  'DISABLE_SSO',
  'SUPPORT_ACCESS_ENABLED',
  'SUPPORT_ACCESS_DISABLED',
  'CREATE_WORKSPACE',
  'UPDATE_WORKSPACE',
  'CHANGE_RESTRICTED_UPLOADS',
  'SET_RESTRICTED_UPLOADS_ELIGIBILITY',
  'SET_WORKSPACE_EXPIRED_VERSIONS_RULES',
  'DELETE_ORGANIZATION',
  'TRANSFER_ORGANIZATION',
]
